export class RoleTemplate {

  id?: string | null;
  roleType?: string | null;
  applicationId?: string | null;
  moduleId?: string | null;
  name?: string | null;
  isActive?: boolean | null;
  intDescription?: string | null;

  lastModifiedBy?: string | null;
  lastModifiedOn?: Date | null;

  roleTypeName?: string | null;
  lastModifiedByName?: string | null;
}
